import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X, ChevronDown } from 'lucide-react';
import '../styles/Navigation.css';

const Navigation = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [productDropdownOpen, setProductDropdownOpen] = useState(false);
  const location = useLocation();

  const isActive = (path) => {
    return location.pathname === path || location.pathname.startsWith(path + '/');
  };

  return (
    <nav className="navigation-header">
      <div className="container">
        <div className="nav-content">
          <Link to="/" className="navigation-logo">
            <img 
              src="https://customer-assets.emergentagent.com/job_transparent-tofu/artifacts/xqb7fx6c_naru%20tofu%20logo.jpg" 
              alt="Naru Tofu" 
              className="logo-image"
            />
          </Link>
          
          <ul className={`navigation-menu ${mobileMenuOpen ? 'mobile-open' : ''}`}>
            <li>
              <Link 
                to="/about" 
                className={`navigation-link ${isActive('/about') ? 'active' : ''}`}
                onClick={() => setMobileMenuOpen(false)}
              >
                About
              </Link>
            </li>
            <li 
              className="nav-dropdown"
              onMouseEnter={() => setProductDropdownOpen(true)}
              onMouseLeave={() => setProductDropdownOpen(false)}
            >
              <button 
                className={`navigation-link ${isActive('/products') ? 'active' : ''}`}
                onClick={() => setProductDropdownOpen(!productDropdownOpen)}
              >
                Product
                <ChevronDown size={14} style={{ marginLeft: '4px' }} />
              </button>
              {productDropdownOpen && (
                <ul className="dropdown-menu">
                  <li>
                    <Link 
                      to="/products/tofu" 
                      className="dropdown-item"
                      onClick={() => {
                        setMobileMenuOpen(false);
                        setProductDropdownOpen(false);
                      }}
                    >
                      Momen Firm Tofu
                    </Link>
                  </li>
                  <li>
                    <Link 
                      to="/products/soymilk" 
                      className="dropdown-item"
                      onClick={() => {
                        setMobileMenuOpen(false);
                        setProductDropdownOpen(false);
                      }}
                    >
                      Fresh Soymilk
                    </Link>
                  </li>
                </ul>
              )}
            </li>
            <li>
              <Link 
                to="/benefits" 
                className={`navigation-link ${isActive('/benefits') ? 'active' : ''}`}
                onClick={() => setMobileMenuOpen(false)}
              >
                Benefits
              </Link>
            </li>
            <li>
              <Link 
                to="/transparency" 
                className={`navigation-link ${isActive('/transparency') ? 'active' : ''}`}
                onClick={() => setMobileMenuOpen(false)}
              >
                Transparency
              </Link>
            </li>
            <li>
              <Link 
                to="/movement" 
                className={`navigation-link ${isActive('/movement') ? 'active' : ''}`}
                onClick={() => setMobileMenuOpen(false)}
              >
                Movement
              </Link>
            </li>
            <li>
              <Link 
                to="/contact" 
                className={`navigation-link ${isActive('/contact') ? 'active' : ''}`}
                onClick={() => setMobileMenuOpen(false)}
              >
                Contact
              </Link>
            </li>
            <li>
              <Link 
                to="/blog" 
                className={`navigation-link ${isActive('/blog') ? 'active' : ''}`}
                onClick={() => setMobileMenuOpen(false)}
              >
                Blog
              </Link>
            </li>
          </ul>
          
          <button 
            className="mobile-menu-toggle"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            aria-label="Toggle menu"
          >
            {mobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
      </div>
    </nav>
  );
};

export default Navigation;
